import axios from 'axios';

/**
 * Updates summary data based on the selected data mode (lifetime or 7-day)
 * @param {Array} vinShort - Array of vehicle VIN numbers
 * @param {string} dataMode - 'lifetime' or '7day'
 * @returns {Promise} - Promise resolving to updated summary data
 */
const updateSummaryDataMode = async (vinShort, dataMode) => {
  try {
    // Determine base URL based on hostname
    let baseURL;
    if (window.location.hostname === "simbaanalytics-dev.rio.cloud") {
      baseURL = "https://26ovsbph5oz6xpn2fgscmr5x5i0socao.lambda-url.eu-west-1.on.aws";
    } else if (window.location.hostname === "bev-dev.simbaanalytics-dev.rio.cloud") {
      baseURL = "https://spv3toxlwj.execute-api.eu-west-1.amazonaws.com/test_cognito";
    } else if (window.location.hostname === "bev-prod.simbaanalytics-dev.rio.cloud") {
      baseURL = "https://dnz0zln7l2.execute-api.eu-west-1.amazonaws.com/prod";
    } else {
      baseURL = "http://localhost:8080";
    }

    // Get authentication token
    const token = localStorage.getItem("idToken");
    
    if (!token) {
      console.error("No ID token found! User might not be authenticated.");
      throw new Error("Authentication token not found");
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    // Make a POST request to the backend endpoint
    const response = await axios.post(`${baseURL}/summary-data-mode`, {
      vin_short: vinShort,
      data_mode: dataMode
    }, { headers });
    
    return response.data.summary_data;
  } catch (error) {
    console.error('Error updating summary data mode:', error);
    throw error;
  }
};

export default updateSummaryDataMode;